import React from 'react';

export type LandingProseSectionProps = {
  id: string;
  title: string;
  children: React.ReactNode;
  className?: string;
};

/**
 * Informativ brödtext på landningssidor.
 * Samma ytterbredd som ikonkorten (max-w-6xl), en kolumn.
 */
const LandingProseSection: React.FC<LandingProseSectionProps> = ({
  id,
  title,
  children,
  className = 'relative z-10 mx-auto mb-24 w-full max-w-6xl',
}) => (
  <section className={className} aria-labelledby={id}>
    <header className="mb-10 text-center md:mb-12">
      <h2
        id={id}
        className="mx-auto max-w-3xl text-balance text-3xl font-bold leading-snug tracking-tight text-white md:text-4xl"
      >
        {title}
      </h2>
      <div className="mx-auto mt-5 h-px w-12 bg-purple-400/90 md:mt-6" aria-hidden />
    </header>

    <div
      className={[
        'w-full max-w-6xl',
        'space-y-8 md:space-y-10',
        'text-left text-[1.0625rem] text-slate-300/95 md:text-lg',
        'leading-[1.85] md:leading-[1.9]',
        'tracking-[0.01em]',
        '[&_p]:m-0',
        '[&_a]:font-medium [&_a]:text-purple-300 [&_a]:underline [&_a]:decoration-purple-500/50 [&_a]:underline-offset-[5px]',
        '[&_a]:transition-colors hover:[&_a]:text-purple-200',
        '[&_button]:font-medium [&_button]:text-purple-300 [&_button]:underline [&_button]:decoration-purple-500/50 [&_button]:underline-offset-[5px]',
        '[&_button]:transition-colors hover:[&_button]:text-purple-200',
      ].join(' ')}
    >
      {children}
    </div>
  </section>
);

export default LandingProseSection;
